export enum Subjects {
  Anomalies = "Anomalies",
  Assessment = "Assessment",
  Alerts_Dashboard = "Alerts Dashboard",
  Application_Dashboards = "Application Dashboards",
  Availability_Groups_Dashboard = "Availability Groups Dashboard",
  Billing = "Billing",
  Blocking_Dashboard = "Blocking Dashboard",
  Client_Connections_Dashboard = "Client Connections Dashboard",
  Client_Information = "Client Information",
  Client_MSP_Information = "Client MSP Information",
  Client_Onboarding = "Client Onboarding",
  Collector_Health_Admin = "Collector Health - Admin",
  Collector_Health_Client = "Collector Health - Client",
  Database_Dashboards = "Database Dashboards",
  Deadlocks_Dashboard = "Deadlocks Dashboard",
  Environment_Management = "Environment Management",
  FindingsViewAll = "Findings - View All", //do not change
  Fortified_Support = "Fortified Support",
  Host_Dashboards = "Host Dashboards",
  Instance_Dashboards = "Instance Dashboards",
  Job_Dashboards = "Job Dashboards",
  Maintenance_Task_Management = "Maintenance Task Management",
  Metrics_Dashboard = "Metrics Dashboard",
  Monitoring_Management = "Monitoring Management",
  Query_Statistics_Dashboard = "Query Statistics Dashboard",
  SQL_Activity_Dashboard = "SQL Activity Dashboard",
  SQL_Audit_Dashboard = "SQL Audit Dashboard",
  Security_Dashboard = "Security Dashboard",
  User_Management = "User Management",
  Index_Dashboards = "Index Dashboards",
  Cloud_Migration_Assessment = "Cloud Migration Assessment",
  AskWisdom = "Ask WISdom",
  AskWisdom_Advisor = "AskWisdom Advisor",
  Tagging = "Tagging",
  V2_Screens = "V2 Screens",
  Admin_Console = "Admin Console",
  Cost_Management = "Cost Management",
  Integration_Admin = "Integration Admin",
  User_Settable_Management = "User Settable Management",
  CollectorAdmin = "Collector Admin",
  Performance_Counter_Template_Management = "Performance Counter Template Management",
  Alerting_Management = "Alerting Management",
  User_Profile = "User Profile",
  Calculators = "Calculators",
  Silencing_Windows = "Silencing Windows",
  Reporting = "Reporting",
  Queue_Automated_Performance_Tuning = "Queue Automated Performance Tuning",
  Subscription_Management = "Subscription Management",
  Infrastructure_Hosts = "Infrastructure Hosts",
  Infrastructure_Instances = "Infrastructure Instances",
  Infrastructure_Databases = "Infrastructure Databases",
}

export enum Roles {
  Admin = "Admin",
  Read = "Read",
  Write = "Write",
}
